import { useTranslation } from 'react-i18next';
import React, {useState, Fragment, useEffect} from 'react';
import {useNavigate,useParams} from "react-router-dom";
import { useMessage } from '../../context/message-context';
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import DynamicTable from "../shared/components/DynamicTableComponent";
import DetailsBox from "../shared/components/DetailsBox";
import apiRequest from '../../functions/api';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { Button,Grid,TextField,MenuItem,} from "@mui/material";
function MandatoryDocConfirmation(props) {
  const { t } = useTranslation();
    let { pflichtdok } = useParams();
    const navigate = useNavigate();
    const { accessToken,  client} = props;
    const [isLoading, setIsLoading] = useState(false);
    const {hideMessage, showErrorMessage,showSuccessMessage} = useMessage();
    const [zeilen,setZeilen] = useState([]);
    const [ueber,setUeber] = useState([]);
    const [filterdok,setFilerdok] = useState(pflichtdok?pflichtdok:"Alle");
    const [documents,setDocuments] = useState([]);
    const [options,setOptions] = useState([]);
    const [letzterkey,setLetzterKey]=useState("");
    const [open,setOpen]=useState(false);
    const [details,setDetails]=useState([]);
  useEffect(() => {
    ladeDocuments()
  // eslint-disable-next-line
  }, [])
  useEffect(() => {
      hole_Tabelle()
  // eslint-disable-next-line
  }, [filterdok])
  
  const ladeDocuments = () => {
    setIsLoading(true);
    const payload={
      "mandant": client,
      "program": "WEBPDS",
      "statement": "HOLE_DOKUMENTE",
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, documentCb);
  }
  const documentCb = (response) => {
    if (response.status === 200) {
        if (response.data.doks) {
          setDocuments(response.data.doks);
        } else {
          setDocuments([]);
        }
        setIsLoading(false);
        hideMessage();
    } else {
        if (response) {
          showErrorMessage(response.data.message);
        } else {
          showErrorMessage(t("Keine Internetverbindung"));
        }
    }      
  }
    
  const hole_Tabelle = (loeschen) => {
      setIsLoading(true);
      const payload={
        "mandant": client,
        "program": "WEBPDS",
        "statement": "BESTAETIGUNGEN_HOLEN",
        "pflichtdok":filterdok,
        "letzterkey":letzterkey,
        "loeschen":loeschen,
      }
      const headers={
        "Authorization": "Bearer "+accessToken,
      }
      apiRequest('POST', 'daten', payload, headers, tabelleCB,errorcB);
    }
  const tabelleCB = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
        if (response.data.ueberschrift) {
          setUeber(response.data.ueberschrift);
        }
        if (response.data.zeilen) {
          setZeilen(response.data.zeilen);
        } else {
          setZeilen([])
        }
        if (response.data.options) {
          setOptions(response.data.options);
        }
        if (response.data.letzter_key) {
          setLetzterKey(response.data.letzter_key);
        }
    } else {
        if (response) {
          showErrorMessage(response.data.message);
        } else {
          showErrorMessage(t("Keine Internetverbindung"));
        }
    }      
  }
  
  const sende_emails = () => {
    setIsLoading(true);
    const payload={
      "mandant": client,
      "program": "WEBPDS",
      "statement": "MAIL_ERNEUT_SENDEN",
      "pflichtdok":filterdok,
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, mailCB,errorcB);
  }
  const mailCB = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
        if (response.data.ueberschrift) {
          setUeber(response.data.ueberschrift);
        }
        if (response.data.zeilen) {
          setZeilen(response.data.zeilen);
        } 
        if (response.data.options) {
          setOptions(response.data.options);
        }
        if (response.data.letzter_key) {
          setLetzterKey(response.data.letzter_key);
        }
        if (response.data.mail_gesendet) {
          showSuccessMessage(response.data.mail_gesendet);
        }
    } else {
        if (response) {
          showErrorMessage(response.data.message);
        } else {
          showErrorMessage(t("Keine Internetverbindung"));
        }
    }      
  }
  const hole_details = (zeile) => {
    setIsLoading(true);
    const payload={
      "mandant": client,
      "program": "WEBPDS",
      "statement": "DETAILS_HOLEN",
      "pflichtdok":filterdok,
      "zeile":zeile,
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, detailsCB,errorcB);  
  }
  const detailsCB = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
        if (response.data.details) {
          setDetails(response.data.details);
          setOpen(true);
        }
    } else {
        if (response) {
          showErrorMessage(response.data.message);
        } else {
          showErrorMessage(t("Keine Internetverbindung"));
        }
    }      
  }
  const errorcB = () => {
    setIsLoading(false);
    showErrorMessage(t("Keine Internetverbindung. Bitte erneut versuchen"));
}
if (isLoading) {
    return <LoadingComponent />
}
  const filterdok_aendern = (wert) => {
    setFilerdok(wert);
    navigate("/WEBPDS/"+wert, {replace: true});
  }
  const tableButton = (button_id,zeile) => {
     if (button_id==="zeigen") {
      hole_details(zeile); 
     }
     if (button_id==="loeschen") {
      hole_Tabelle(zeile); 
     }
  }
  return (
    <Fragment>
        <Page>
            <Layout>
            <Grid container justifyContent="center">
            <Grid item xs={12}>
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={12}>
                <TextField
                  select
                  variant="outlined"
                  label={t("Pflichtdokument")}
                  value={filterdok}
                  onChange={(event) => filterdok_aendern(event.target.value)}
                  fullWidth
                  margin="normal"
                  InputLabelProps={{
                    shrink: true,
                  }}
                >
                  <MenuItem value="Alle">{t("Alle")}</MenuItem>
                  { documents.map((element)=> {
                      return (
                        <MenuItem value={element.key}>{element.bez}</MenuItem>
                      )
                    })
                  } 
                </TextField>  
              </Grid>
              { filterdok!=="Alle"  && 
                <Grid item xs={12} sm={6}  alignItems="center" >
                  <Button variant="contained" color="primary"  fullWidth onClick={()=> navigate("/WEBPDS/mitarbeiter/"+filterdok) } >{t(" Mitarbeiter hinzufügen")}</Button>
                </Grid>
              }
               <Grid item xs={12} >
                <DynamicTable  zeilen={zeilen} spalten={ueber} options={options} leertext={"Es wurden bisher keine Mitarbeiter hinzugefügt"} hoehe={800} buttonCb={(spaltenkey,zeilenkey) => tableButton(spaltenkey,zeilenkey,)} minbreite={500}  size={"small"}/>   
              </Grid>
              
              <Grid item xs={12} sm={6}  alignItems="center" >
                <Button variant="contained" color="primary" fullWidth  onClick={()=> sende_emails() } >{t(" Erinnerungs-Mail versenden")}</Button>
              </Grid>
              <DetailsBox
                open={open}
                details={details}
                title={t("Detailsansicht")}
                onClose={() => setOpen(false)}        
              />
        </Grid>
        </Grid>
        </Grid>
            </Layout>
        </Page>
    </Fragment>
  )
}
export default MandatoryDocConfirmation; 
